import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Text } from '@houzz/ui';
import Github from './github';
import { StatusBadge } from './status-badge';
import { isLoggedIn } from '../services/auth';

const StyledBlurb = styled(Box)`
    code {
        padding: 1px 6px;
        background: ${(props) => props.theme.colors.accentTint || '#ececec'};
        border-radius: 5px;
        display: inline-block;
        font-size: 0.72rem;
    }
`;

const Hero = ({ header, children, externalLink, status }) => {
    const _isLoggedIn = isLoggedIn();
    return (
        <Box mx="-30px" bg="bg.tertiary" mt="-20px" py="XXXL" px="XXL">
            <Text as="h1" mt="Zero" size="Mega" fontWeight="900">
                {header}
                {status && <StatusBadge status={status} ml="S" />}
            </Text>
            {/*Temporaily disable links to internal pages. We can add a login to the header later on*/}
            {_isLoggedIn && externalLink && <Github link={externalLink} />}
            <StyledBlurb width="80%" dangerouslySetInnerHTML={{ __html: children }} />
        </Box>
    );
};

Hero.propTypes = {
    header: PropTypes.string,
    children: PropTypes.node,
    externalLink: PropTypes.string,
    status: PropTypes.string,
};

export default Hero;
